import { render, staticRenderFns } from "./ChallengeCourse.vue?vue&type=template&id=4b75c0d7&scoped=true"
import script from "./ChallengeCourse.vue?vue&type=script&lang=js"
export * from "./ChallengeCourse.vue?vue&type=script&lang=js"
import style0 from "./ChallengeCourse.vue?vue&type=style&index=0&id=4b75c0d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b75c0d7",
  null
  
)

export default component.exports